var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3525 20.4056C16.3525 20.777 16.0471 21.078 15.6704 21.078H8.25859C7.56058 21.078 7.3131 21.9891 7.91771 22.3329L10.6907 23.91C10.9018 24.0301 11.1618 24.03 11.3728 23.9098L21.3186 18.2462C21.5295 18.126 21.6595 17.9041 21.6595 17.6639V13.1658C21.6595 12.6479 21.0906 12.3244 20.6358 12.5837L16.6931 14.8318C16.4823 14.952 16.3525 15.1739 16.3525 15.4139V20.4056Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.402344 17.6642C0.402344 17.9042 0.532154 18.1261 0.742943 18.2462L4.68567 20.4943C5.14043 20.7536 5.70934 20.4301 5.70934 19.9123V15.4139C5.70934 15.1739 5.57953 14.952 5.36874 14.8318L1.42601 12.5837C0.971257 12.3244 0.402344 12.6479 0.402344 13.1658V17.6642Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4382 5.09646C4.78667 4.50038 4.10977 3.83416 3.50565 4.17862L0.742943 5.75388C0.532153 5.87407 0.402344 6.09592 0.402344 6.33597V9.4865C0.402344 10.1748 1.32688 10.4186 1.67549 9.82226L4.4382 5.09646Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3727 6.14195C11.1618 6.02198 10.9019 6.02198 10.691 6.14195L6.05245 8.77999C5.84129 8.90009 5.71119 9.12214 5.71119 9.36245V14.6377C5.71119 14.878 5.84129 15.1 6.05245 15.2201L10.691 17.8582C10.9019 17.9781 11.1618 17.9781 11.3727 17.8582L16.0112 15.2201C16.2224 15.1 16.3525 14.878 16.3525 14.6377V9.36245C16.3525 9.12214 16.2224 8.90009 16.0112 8.77999L11.3727 6.14195Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5538 4.17862C17.9497 3.83416 17.2728 4.50039 17.6212 5.09646L20.384 9.82226C20.7326 10.4186 21.6571 10.1748 21.6571 9.4865V6.33597C21.6571 6.09592 21.5273 5.87407 21.3165 5.75388L18.5538 4.17862Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3727 0.0899822C11.1618 -0.0299942 10.9019 -0.029994 10.691 0.0899824L6.73534 2.33964C6.28033 2.59842 6.28033 3.24579 6.73534 3.50456L10.691 5.75422C10.9019 5.8742 11.1618 5.8742 11.3727 5.75422L15.3283 3.50456C15.7834 3.24579 15.7834 2.59842 15.3283 2.33964L11.3727 0.0899822Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestBlackLogo);
export default __webpack_public_path__ + "static/media/QuestBlackLogo.39c37c2ff15e9fb870f82b939716c0f0.svg";
export { ForwardRef as ReactComponent };